/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, ReactElement } from "react";

import { Icon, Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";

import { UILuggageAllowance } from "@flights/types";
import FlightDetailsAncillaryItemLayout from "../../FlightDetailsAncillaryItemLayout";
import { includedBaggageIcons } from "@flights/branded-fares";
import { SPACER_PADDED } from "@flights/constants";
import { formattingUtils } from "@flights/web-api-utils-universal";

export const BaggageItem: FC<{
  luggage: UILuggageAllowance;
  subtitle?: ReactElement;
  hideIncludedSection?: boolean;
  footer?: any;
  alignIconCenter?: boolean;
  extraTestId?: string;
}> = ({
  luggage,
  subtitle = null,
  hideIncludedSection = false,
  footer = null,
  alignIconCenter = false,
  extraTestId
}) => {
  const i18n = useI18n();

  const IconSVG = includedBaggageIcons[luggage.luggageType];
  const { title, size, weightPerPiece, totalWeight } = formattingUtils.luggageAllowanceCopyV2(luggage, i18n);
  const restrictions = [size, totalWeight, weightPerPiece].filter(Boolean);

  return (
    <FlightDetailsAncillaryItemLayout
      icon={<Icon svg={IconSVG} size="large" />}
      content={
        <>
          <Text attributes={{ "data-testid": "baggage_title" }} variant="body_2">
            {title}
          </Text>
          {subtitle}

          {restrictions.length > 0 && (
            <Text attributes={{ "data-testid": "baggage_description" }} variant="body_2">
              {restrictions.join(SPACER_PADDED)}
            </Text>
          )}
          {footer}
        </>
      }
      includedBaggage={true}
      hideIncludedSection={hideIncludedSection}
      alignIconCenter={alignIconCenter}
      extraTestId={extraTestId}
    />
  );
};
